import type { ApiErrorResponse } from '@/models';

export const getApiErrorMessage = (
  error: unknown,
  fallbackMessage: string,
): string => {
  if (typeof error === 'object' && error !== null && 'response' in error) {
    const response = (error as { response?: { data?: ApiErrorResponse } })
      .response;

    if (
      typeof response?.data?.message === 'string' &&
      response.data.message.trim().length > 0
    ) {
      return response.data.message;
    }
  }

  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }

  return fallbackMessage;
};
